import tier from "./tier";
import scheduler from "./scheduler";
import skinConcern from "./skin-concern";
import skinType from "./skin-type";
import community from "./community";
import chatManagement from "./chat-management";
import campaign from "./campaign";

export default [
  tier,
  scheduler,
  skinConcern,
  skinType,
  community,
  chatManagement,
  campaign
]
